<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('JUDUL_DIS')" :class="{'form-group': true, 'has-error': errors.has('judul')}">
        <label class="col-md-3"><span class="required-label">*</span>Judul Rencana Disertasi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="judul"
            placeholder="Judul Rencana Disertasi"
            class="form-control"
            maxlength="255"
            v-model="model.judul"
            v-validate="isExist('JUDUL_DIS') ? 'required' : ''"
          >
          <span v-show="errors.has('judul')" class="error-label">Isi Judul Rencana Disertasi</span>
        </div>
      </div>
      <div v-show="isExist('FILE_DIS')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>File Rencana Disertasi</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointFileDisertasi"
            :headers="header"
            name="file_disertasi"
            :data="dataUpload"
            :on-error="handleError"
            :on-success="handleSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_disertasi"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="disertasiUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="disertasiUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      disertasiUrl: null,
      model: {
        judul: null
      },
      savedModel: null,
      file: {
        file_disertasi: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointFileDisertasi () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/judul_disertasi/disertasi'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(20).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let disertasiUploaded = this.file.file_disertasi.length > 0
              !disertasiUploaded && this.isExist('FILE_DIS') ? reject({message: 'belum ada file disertasi'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 20)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.getFileDisertasi()
        this.init = true
      }
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_disertasi = [{name: 'disertasi_' + this.nomorPendaftar + '.pdf'}]
        this.disertasiUrl = 'test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleSuccess (res, file) {
      this.getFileDisertasi()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getData () {
      this.loading = true
      api.get('/v1/judul_disertasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model = responseData.data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getFileDisertasi () {
      api.get('/v2/judul_disertasi/disertasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_disertasi = [{name: 'disertasi_' + this.nomorPendaftar + '.pdf'}]
            this.disertasiUrl = responseData.url
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/judul_disertasi', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                let success = response.data.success
                if (success) {
                  this.sending = false
                  this.savedModel = model
                  resolve(response.data)
                }
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataDisertasi.vue